import { Box, Divider, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { InfoIconWithPopover } from "../../../../components/Title/InfoIconWithPopover";

export function CompanyCardDescriptionMaximumAdvancedBooking() {
  const { t } = useTranslation();

  return (
    <InfoIconWithPopover title={t("Maximum advanced booking")}>
      <Box sx={{ p: 1, maxWidth: 640 }}>
        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.intro" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.calibration" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.weekdayOnly" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.timeOnly" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.daysRule" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.weeksFallback" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.daysOverride" />
        </Typography>

        <Typography variant="body1" color="text.secondary">
          <Trans i18nKey="maxAdvBookingHelp.endOfDay" />
        </Typography>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={1}></Stack>
        <Box sx={{ p: 1, borderRadius: 1, bgcolor: "action.hover" }}>
          <Typography variant="subtitle2" gutterBottom>
            <Trans i18nKey="maxAdvBookingHelp.Example" />
          </Typography>

          <ul>
            <li>
              <Trans i18nKey="maxAdvBookingHelp.Example_AllowedDays" />
            </li>
            <li>
              <Trans i18nKey="maxAdvBookingHelp.Example_Weekday" />
            </li>
            <li>
              <Trans i18nKey="maxAdvBookingHelp.Example_Time" />
            </li>
          </ul>

          <Typography variant="body2" sx={{ mt: 0.5, display: "block" }}>
            <Trans i18nKey="maxAdvBookingHelp.Example_FirstCondition" />
          </Typography>

          <Typography variant="body2" sx={{ display: "block" }}>
            <Trans i18nKey="maxAdvBookingHelp.Example_FirstResult" />
          </Typography>

          <Typography variant="body2" sx={{ mt: 0.5, display: "block" }}>
            <Trans i18nKey="maxAdvBookingHelp.Example_SecondCondition" />
          </Typography>

          <Typography variant="body2" sx={{ display: "block" }}>
            <Trans i18nKey="maxAdvBookingHelp.Example_SecondResult1" />
          </Typography>

          <Typography variant="body2" sx={{ display: "block" }}>
            <Trans i18nKey="maxAdvBookingHelp.Example_SecondResult2" />
          </Typography>
        </Box>
      </Box>
    </InfoIconWithPopover>
  );
}
